import React, { useEffect } from 'react';
import Modal from 'react-modal';
import '../../styles/CustomModal.css';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import NumberPad from '../../components/NumberPad';

interface ModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onSuccess?: any;
  numberTemp: string;
  setNumberTemp: any;
}

const OrderRollbackModal: React.FC<ModalProps> = ({
  isOpen,
  onCancel,
  onSuccess,
  numberTemp,
  setNumberTemp,
}) => {
  const changeNumber = (value: string) => {
    if (value.length <= 4 && /^\d*$/.test(value)) {
      setNumberTemp(value);
    }
  };
  const maskingBoxes = () => {
    const boxes = Array.from({ length: 4 }).map((_, index) => (
      <div key={index} className="boxWrap">
        {numberTemp[index] ? (
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="9" cy="9" r="9" fill="#4DD2AE" />
          </svg>
        ) : null}
      </div>
    ));

    return boxes;
  };
  useEffect(() => {
    if (numberTemp.length === 4) {
      onSuccess();
    }
  }, [numberTemp]);
  useEffect(() => {
    setNumberTemp('');
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      className="bottom-modal"
      closeTimeoutMS={100}
      ariaHideApp={false}
      style={{
        overlay: {
          height: '100vh',
          display: 'flex',
          alignItems: 'flex-end',
          bottom: '0',
        },
      }}>
      <Style>
        <div>
          <div className="modalContentWrap">
            <div className="topWrap">
              <div className="bar"></div>
              <h2>사용완료 복원</h2>
              <p>본 건은 사용완료 전으로 복원됩니다</p>
              <img
                onClick={onCancel}
                className="closeIcon"
                src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
                alt="닫기 아이콘"
              />
            </div>
            <div>
              <div className="maskingWrap">{maskingBoxes()}</div>
              <NumberPad number={numberTemp} setNumber={changeNumber} />
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default OrderRollbackModal;
const Style = styled.div`
  h2 {
    margin: 20px 0 27px 0;
    font-size: 20px;
    font-weight: 600;
    color: #555;
  }
  p {
    font-size: 1rem;
    font-weight: 500;
    color: #999;
    line-height: 25px;
  }

  .modalContentWrap {
    width: 100vw;
    height: 87vh;
    position: relative;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    background: #fff;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    padding-bottom: 50px;
  }
  .topWrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    .bar {
      width: 30px;
      height: 4px;
      background: #4dd2ae;
    }
  }
  .closeIcon {
    position: absolute;
    right: 10px;
    top: 10px;
  }

  /* numberPadWrap */
  .numberPadWrap {
    width: 100vw;
    background: #4dd2ae;
    padding-bottom: 70px;

    h2 {
      margin: 0;
      color: #fff;
    }
  }
  .numberTempWrap {
    border: 1px solid red;
  }
  .maskingWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 30px 0;
  }
  .boxWrap {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    border: 1px solid #cecece;
  }
`;
